"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SurchargeTemplatesModule = /** @class */ (function () {
    function SurchargeTemplatesModule() {
    }
    return SurchargeTemplatesModule;
}());
exports.SurchargeTemplatesModule = SurchargeTemplatesModule;
